import { useEffect, useRef } from "react";
import { HEX_COLOR_PATTERN } from "../constants";

export const usePlacementAnimation = (background: string) => {
  const placementRef = useRef<HTMLDivElement | null>(null);

  const mouseMoveHandler = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    const rect = placementRef?.current?.getBoundingClientRect();
    const x = event.clientX - (rect?.left ?? 0);
    const y = event.clientY - (rect?.top ?? 0);

    placementRef?.current?.style.setProperty("--mouse-x", `${x}px`);
    placementRef?.current?.style.setProperty("--mouse-y", `${y}px`);
  };

  useEffect(() => {
    const hexColors = background.match(HEX_COLOR_PATTERN);
    const isGradientBackground = (hexColors?.length ?? 0) > 1;

    // передаем цвет с сервера в стили компоненту через css переменные
    if (!isGradientBackground) {
      document.documentElement.style.setProperty(
        "--gradient-color_1",
        "#cdc7e1"
      );
    } else {
      document.documentElement.style.setProperty(
        "--gradient-color_1",
        hexColors?.[1] ?? ""
      );
    }

    document.documentElement.style.setProperty(
      "--gradient-color_2",
      hexColors?.[0] ?? ""
    );
  }, [background]);

  return { placementRef, mouseMoveHandler };
};
